import { Flex, Text } from '@chakra-ui/react';
import { useMemo } from 'react';

const defaultStyles = {
  color: '#161616',
};

const linkStyles = {
  color: '#444CE7',
  textDecoration: 'underline',
  cursor: 'pointer',
};

export const Link = ({ text, href, onClick, fontWeight = 500, fontSize, ...props }) => {
  const isClickable = useMemo(() => {
    // Only negative and positive numbers are
    // valid clickable entries.
    if (typeof text === 'number') {
      if (text === 0) {
        return false;
      }
    }
    if (typeof onClick !== 'function') {
      return false;
    }
    return true;
  }, [text, onClick]);

  return (
    <Flex w="100%" justifyContent="center" {...props}>
      <Text
        fontSize={fontSize ?? '14px'}
        lineHeight="24px"
        overflow="hidden"
        textOverflow="ellipsis"
        fontWeight={fontWeight}
        letterSpacing="0.01em"
        {...(isClickable ? linkStyles : defaultStyles)}
        onClick={() => {
          if (isClickable) {
            onClick?.();
          }
        }}
      >
        {text}
      </Text>
    </Flex>
  );
};
